import React from 'react';

const ConfirmModal = ({ isOpen, title, message, onConfirm, onCancel, confirmText = 'Confirm', confirmColor = '#ef4444' }) => {
    if (!isOpen) return null;
    return (
        <div className="modal-overlay" onClick={onCancel} style={{ zIndex: 9999 }}>
            <div className="modal-container" style={{ maxWidth: '400px', width: '90%', padding: '1.5rem', textAlign: 'center' }} onClick={e => e.stopPropagation()}>
                <div style={{ marginBottom: '1rem' }}>
                    <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: '#fee2e2', color: '#ef4444', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1rem' }}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="8" x2="12" y2="12"></line>
                            <line x1="12" y1="16" x2="12.01" y2="16"></line>
                        </svg>
                    </div>
                    <h3 style={{ margin: '0 0 0.5rem', fontSize: '1.25rem', color: '#1e293b' }}>{title}</h3>
                    <p style={{ margin: 0, color: '#64748b', fontSize: '0.95rem' }}>{message}</p>
                </div>
                <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', marginTop: '1.5rem' }}>
                    <button style={{ padding: '0.5rem 1.25rem', background: 'white', color: '#475569', border: '1px solid #cbd5e1', borderRadius: '6px', cursor: 'pointer', fontWeight: 600 }} onClick={onCancel}>Cancel</button>
                    <button style={{ padding: '0.5rem 1.25rem', background: confirmColor, color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 600 }} onClick={onConfirm}>{confirmText}</button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
